import PersonalInfo from 'modules/Onboarding/Register/PersonalInfoNew'
import Education from 'modules/Onboarding/Register/EducationNew'
import ProjectInternship from 'modules/Onboarding/Register/ProjectInternshipNew'
import WorkExperience from 'modules/Onboarding/Register/WorkExperienceNew'
import CourseTraining from 'modules/Onboarding/Register/CourseTraining/'
import ProofDocuments from 'modules/Onboarding/Register/ProofDocuments'
import AdditionalDetails from 'modules/Onboarding/Register/AdditionalDetails'
import CVupload from 'modules/Onboarding/Register/CVupload'
import ProfileUpload from 'modules/Onboarding/Register/ProfileUpload'

export const menuData = [
  {
    key: 1,
    activeKey: 0,
    title: 'Resume Upload',
    heading: 'Resume Upload',
    component: CVupload,
  },
  {
    key: 2,
    activeKey: 1,
    title: 'Profile Upload',
    heading: 'Profile Upload',
    component: ProfileUpload,
  },
  {
    key: 3,
    activeKey: 2,
    title: 'Personal Details',
    heading: 'Personal Details',
    component: PersonalInfo,
  },
  {
    key: 4,
    activeKey: 3,
    title: 'Educational Details',
    heading: 'Educational Details',
    component: Education,
  },
  {
    key: 5,
    activeKey: 4,
    title: 'Project & Internship',
    heading: 'Project/Internship Details',
    component: ProjectInternship,
  },
  {
    key: 6,
    activeKey: 5,
    title: 'Work Experience',
    heading: 'Work Experience',
    component: WorkExperience,
  },
  {
    key: 7,
    activeKey: 6,
    title: 'Courses & Training',
    heading: 'Course/Training Details',
    component: CourseTraining,
  },
  {
    key: 8,
    activeKey: 7,
    title: 'Proof/Documents',
    heading: 'Proof/Documents',
    component: ProofDocuments,
  },
  {
    key: 9,
    activeKey: 8,
    title: 'Additional Details',
    heading: 'Additional Details',
    component: AdditionalDetails,
  },
]
